<div class="payment-status" [class.center]="alignCenter()">
  <img [src]="img" [alt]="paymentDTO().status" class="status-icon" />
  <span class="status-text">{{ label() }}</span>
  @if (showModal()) {
  <img (click)="openModal = true" src="../assets/lib/icons/alerts/i.svg" alt="Information" class="information-icon" />
  }
</div>

@if (showModal()) {
  <div class="modal">
    <app-dialog [opened]="openModal" (openedChange)="openModal = false" [modalCenter]="true">
      <div class="content center">
        <ng-content select="[modal-title]" />
        <div class="text-center">
          <ng-content select="[modal-content]" />
        </div>
        <lib-button id="right-btn" type="primary" [rightIcon]="true" (clickButton)="openModal = false" class="dialog-button">
          OK
        </lib-button>
      </div>
    </app-dialog>
  </div>
}
